import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { PrivateRoute } from './privateRoute'
import { AuthRoute } from './authRoute'
import { NotFound } from 'src/pages/notFound/NotFound'
// Routes
import { AppRoutes } from './routes'

import { AppLayout } from 'src/components/appLayout/AppLayout'
import { AuthLayout } from 'src/components/authLayout/AuthLayout'
import { useAuthStore } from 'src/store/auth'

function Router() {
  const { setUpUser, user } = useAuthStore((store) => store)

  useEffect(() => {
    const storageUser = window.localStorage.getItem('user')

    if (storageUser && !user) {
      setUpUser()
    }
  })

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path='*'
          element={
            <AppLayout>
              <NotFound />
            </AppLayout>
          }
        />
        {AppRoutes.map((route) => {
          if (route.meta?.privateRoute) {
            return (
              <Route
                key={route.path}
                path={route.path}
                exact={route.exact}
                element={<PrivateRoute route={route}/>}
              >
                <Route
                  path={route.path}
                  exact={route.exact}
                  element={<AppLayout>{route.component}</AppLayout>}
                />
              </Route>
            )
          }
          if (route.meta?.authRoute) {
            return (
              <Route
                key={route.path}
                path={route.path}
                exact={route.exact}
                element={<AuthRoute />}
              >
                <Route
                  path={route.path}
                  exact={route.exact}
                  element={<AuthLayout>{route.component}</AuthLayout>}
                />
              </Route>
            )
          }
          return (
            <Route
              key={route.path}
              path={route.path}
              exact={route.exact}
              element={<AppLayout>{route.component}</AppLayout>}
            />
          )
        })}
      </Routes>
    </BrowserRouter>
  )
}

export default Router
